import React from "react";
import Navbar from "../homepage/Navbar";
import {Footer} from "../../shared";

const Financial = () => {
  const benefits = [
    {
      icon: "ri-money-dollar-circle-line",
      title: "Affordable EMI Plans",
      description:
        "Break down the cost of your drone or drone service into manageable monthly payments with zero or low interest."
    },
    {
      icon: "ri-government-line",
      title: "Government Subsidy Guidance",
      description:
        "We help you explore and apply for agriculture and startup-related drone subsidies offered by central and state governments."
    },
    {
      icon: "ri-rocket-line",
      title: "Startup & MSME Support",
      description:
        "Need drones for your drone-based startup? We'll guide you through funding schemes, eligibility, and application support."
    },
    {
      icon: "ri-graduation-cap-line",
      title: "Student Loan Assistance",
      description:
        "Enrolled in drone training or RPTO certification? Apply for education loan assistance through our partnered institutions."
    }
  ];

  const eligibleGroups = [
    {
      icon: "ri-plant-line",
      title: "Farmers and Agri-entrepreneurs",
      description: "Agricultural professionals seeking drone technology for farming operations"
    },
    {
      icon: "ri-service-line",
      title: "Drone Service Providers",
      description: "DaaS vendors looking to expand their drone fleet and services"
    },
    {
      icon: "ri-user-2-line",
      title: "Students & RPTO trainees",
      description: "Individuals pursuing drone education and certification programs"
    },
    {
      icon: "ri-building-3-line",
      title: "Startups and MSMEs",
      description: "Small businesses and startups venturing into drone technology"
    },
    {
      icon: "ri-school-line",
      title: "Educational Institutions",
      description: "Schools and colleges integrating drone technology into their curriculum"
    }
  ];

  const steps = [
    {
      step: "01",
      title: "Submit Your Request",
      description:
        "Fill out a simple form with your requirements and eligibility.",
      icon: "ri-file-text-line"
    },
    {
      step: "02",
      title: "Get Personalized Support",
      description:
        "Our team reviews your request and connects you with the right financial options—EMI plans, subsidies, or partner lenders.",
      icon: "ri-customer-service-2-line"
    },
    {
      step: "03",
      title: "Own or Access Your Drone",
      description:
        "Once approved, you're ready to take flight with your new equipment or service.",
      icon: "ri-drone-line"
    }
  ];

  return (
    <>
    < Navbar />
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
 <section className="relative bg-gradient-to-br from-blue-700 to-blue-900 text-white py-20 overflow-hidden">
  {/* Background Image Overlay */}
  <div
    className="absolute inset-0 bg-cover bg-center opacity-30"
    style={{
      backgroundImage:
        "url('https://images.unsplash.com/photo-1581092334418-7c12dfecf9d2?auto=format&fit=crop&w=1950&q=80')"
    }}
  ></div>

  {/* Content */}
  <div className="relative z-10 max-w-6xl mx-auto px-6">
    <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-10 md:p-16 text-center shadow-lg">
      <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
        Fuel Your Dreams with <span className="text-yellow-300">Drone Financing</span>
      </h1>
      <p className="text-lg md:text-xl text-white/90 mb-4">
        Access affordable financing options to kickstart your drone journey—whether you're a farmer, student, or startup.
      </p>
      <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto mb-8">
        DronePlanet helps you take off with ease by connecting you to EMI plans, subsidies, and institutional support for drone adoption.
      </p>

      <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
        <button className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 px-6 py-3 rounded-full font-semibold text-base shadow-md transition-all">
          Apply for Financial Help
        </button>
        <button className="bg-transparent border border-white hover:bg-white hover:text-blue-900 text-white px-6 py-3 rounded-full font-semibold text-base shadow-md transition-all">
          Contact Our Team
        </button>
      </div>
    </div>
  </div>
</section>



      {/* Why Choose */}
   <section className="py-10 bg-gray-50">
  <div className="max-w-7xl mx-auto px-6">
    <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-16">
      Why Choose <span className="text-blue-600">DronePlanet?</span>
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
      {benefits.map((benefit, index) => (
        <div
          key={index}
          className="bg-white rounded-3xl p-8 shadow-md hover:shadow-xl border border-gray-200 transition-shadow duration-300 text-center"
        >
          <div className="w-16 h-16 mx-auto bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-6">
            <i className={`${benefit.icon} text-2xl`}></i>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            {benefit.title}
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* Who Can Apply */}
 <section className="py-10 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">
      Who Can <span className="text-blue-600">Apply?</span>
    </h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
      {eligibleGroups.map((group, index) => (
        <div
          key={index}
          className="group bg-white p-8 rounded-2xl border border-gray-200 hover:border-blue-500 shadow-sm hover:shadow-lg transition-all duration-300"
        >
          <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center mb-6 text-2xl transition-transform duration-300 group-hover:scale-110">
            <i className={group.icon}></i>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">{group.title}</h3>
          <p className="text-gray-600 text-sm leading-relaxed">{group.description}</p>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* How It Works */}
<section className="py-10 bg-gray-50">
  <div className="max-w-7xl mx-auto px-6">
    <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">
      How <span className="text-blue-600">It Works</span>
    </h2>

    <div className="relative grid md:grid-cols-3 gap-10">
      {steps.map((step, index) => (
        <div
          key={index}
          className="bg-white rounded-3xl border border-gray-200 p-8 shadow-md hover:shadow-xl transition duration-300 text-center flex flex-col items-center"
        >
          {/* Vertical Connector Line (for medium and up) */}
          {index < steps.length - 1 && (
            <div className="hidden md:block absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 h-px w-10 bg-blue-200"></div>
          )}

          {/* Step Number */}
          <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center text-base font-bold shadow-md mb-4">
            {step.step}
          </div>

          {/* Icon */}
          <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center text-2xl mb-4">
            <i className={step.icon}></i>
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            {step.title}
          </h3>

          {/* Description */}
          <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
        </div>
      ))}
    </div>
  </div>
</section>



      {/* CTA Section */}
    <section className="py-10 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
  <div className="max-w-4xl mx-auto px-6 text-center">
    <h2 className="text-4xl font-bold mb-4 leading-snug">
      Ready to <span className="text-blue-200">Elevate Your Future</span>?
    </h2>
    <p className="text-lg text-blue-100 mb-10">
      Apply today or connect with our expert team for tailored financial guidance.
    </p>

    <div className="flex flex-col sm:flex-row justify-center gap-4">
      <button className="bg-white text-blue-700 hover:bg-blue-50 transition px-6 py-3 rounded-full font-semibold text-base shadow-lg flex items-center justify-center">
        <i className="ri-file-text-line mr-2 text-lg"></i>
        Apply Now
      </button>
      <button className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-700 transition px-6 py-3 rounded-full font-semibold text-base shadow-md flex items-center justify-center">
        <i className="ri-customer-service-2-line mr-2 text-lg"></i>
        Contact Team
      </button>
    </div>
  </div>
</section>


      {/* Info Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              icon: "ri-shield-check-line",
              title: "Trusted Process",
              desc: "Secure and reliable financing with transparent terms"
            },
            {
              icon: "ri-time-line",
              title: "Quick Approval",
              desc: "Fast processing within 2-3 business days"
            },
            {
              icon: "ri-customer-service-line",
              title: "Expert Support",
              desc: "Guidance from our dedicated finance advisors"
            }
          ].map((item, i) => (
            <div key={i} className="text-center p-4">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-3">
                <i className={`${item.icon} text-blue-600 text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-1">{item.title}</h3>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
    < Footer />
    </>
  );
};

export default Financial;
